module.exports = {
  // / DURING PROD OR STAGGINF BUILD WE HAVE TO CHANGE THE BASEURL MANUALLY IN  /

  //==================STAGING================================ //
  // configbaseUrl: "http://staging.watsoo.com:8085/client-config",
  //  =============================================================

  // ===========================PRODUCTION===========================

  configbaseUrl: "https://ais.watsoo.com/ais-config/config",

  
  /* =================================================================== */
  Username: "admin",
  // Password:'rapid#2021',
  Password: "admin",

  apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw", // production
  // apiKey: "AIzaSyA5Lt3E5gYb-lfogvaSpCrvCpocLqHwNOI", // staging

  NkcWeb: true,
  // VTSWeb:false,
  // BJBWeb:false,
  version: 22.002,
  localhost: "fmsstaging",

  // Api endpoint name
  apiName: {
    SubUsersVehicleList: "api/user-vehicle/notify",
    kycAllApprove: "api/v1/approve/all/kyc/documents",
    kycApproval: "api/v1/approve/kyc/documents",
    getTrail: "api/v1/get/kyc/documents",
    saveKyc: "api/v1/save/kyc/documents",
    fileUpload: "https://storage.nyggs.com/setmedia/api/save/file",
    getKycDetails: "api/v1/check/existing/vendor",
    getKycTypes: "api/v1/documents/all",
    setDefaultDashboard: "api/v1/setUserDefaultDashboard",
    getVehicleDetails: "v1/getFuelDashboard",
    companyList: "api/v1/company/all",
    addNewCompany: "api/v1/company/add",
    AddChainage: `api/v1/import/excelFile`,
    AddPolyline: "/api/v2/import/excelFile",
    GetLatLngBySite: "api/v1/siteConstruction/Order",
    UploadFileOnAWs: "uploadFile",
    loginApi: "v2/login",
    UserList: "api/v1/user/all",
    AddUser: "api/v1/user/add",
    ActiveUser: "api/v1/user/active/inactive",
    UpdateUser: "api/v1/user/update",
    GetUserById: "api/v1/user",
    DesignationList: "v1/designation",
    permission_category: "v1/permission_category",
    RoleList: "v1/role/all",
    SiteList: "api/v1/site/all",
    AddSiteAccess: "api/v1/add/user/site/role",
    RemoveSiteAccess: "api/v1/remove/user/site/role",
    AddRole: "v1/role/add",
    VehicleList: "api/v4/vehicle/all",
    VehicleTypeList: "api/v1/all/vehicle-type",
    importKycExcel: "api/v1/import/kyc/excel",
    ActiveVehicle: "api/v1/vehicle/active/inactive",
    AddVehicle: "api/v1/vehicle/add",
    VehicleById: "api/v1/vehicle/view",
    UpdateVehicle: "api/v1/vehicle/update",
    VendorList: "api/v1/vendor/all",
    AddVendor: "api/v1/vendor/add",
    UpdateVendor: "api/v1/vendor/update",
    VendorById: "api/v1/vendor/view",
    ActiveVendor: "api/v1/vendor/active/inactive",
    DriverList: "api/v1/driver/all",
    DocumentList: "api/v1/documents/all",
    RouteList: "api/v1/route/all",
    AddRoute: "api/v1/route/add",
    ActiveRoute: "api/v1/route/active/inactive",
    RouteById: "api/v1/route/id",
    UpdateRoute: "api/v1/route/update",
    SyncVehicle: "api/v1/sync/vehicle",
    DeleteFile: "deleteFiles",
    EtpOrder: "api/v1/etp/orders/view",
    TotalVendorDashboard: "api/v1/dashbord/status",
    fetchAddress: "address/v1/fetch_address",
    totalInstallGps: "api/v1/dashbord/vehicle/status",
    removeGeoFench: "api/v1/delete/geofence",
    CreateTrip: "api/v1/etp/orders/create",
    TripList: "api/v2/etp/orders/get/all",
    MaterialType: "api/v1/all/material-type",
    DestinationTripSite: "api/v1/get_destinations_from_source",
    ViewTrip: "api/v1/etp/orders/view",
    NotificationAlert: "api/v1/alert/get_all",
    KmlFileUploding: "api/uploadKmlData",
    getFuelDashboard: "getFuelDashboard",
    routeSiteSubSite: "api/v1/site/route/sub_site/all",
    removeGpsFromVehicle: "api/v1/remove/vehicle",
    routeDetele: "api/v1/route/delete",
    auditLog: "api/v1/auditLog",
    AllpermissionName: "api/v1/permission",
    ActiveRoutes: "api/v1/get/active/routes",
    UptimeReport: "api/v1/vehicle/active/inactive/history",
    DieselValue: "api/saveFuelPrice",
    GetNotificationList: "api/v1/get/all/notification/configuration",
    GetDetailList: "api/v1/get/notification/configuration",
    AddNotification: "api/v1/create/notification/configuration",
    EditNotification: "api/v1/edit/notification/configuration",
    NotificationType: "api/v1/get/notification/type",
    AllRemarksShowDetails: "v1/get/all/fuel/droppage/alert/remark",
    Addremarks: "v1/save/fuel/droppage/alert/remarks",
    AllRemarksShowDetails1: "v1/get/all/wire/cut/alert/remark",
    Addremarks1: "v1/save/wire/cut/alert/remarks",
    clientDataFromApi: "/api/get/company/config",
    VehicleStatusList: "v1/get/all/fuel/status?type=DEVICE_FUEL_DROP",
    DieselRequestList: "v1/get/fuel/fill/request",
    DieselRequestCreate: "v2/fuel/fill/request/create",
    DieselRequestApprove: "v1/fuel/fill/request/update",
    DieselRequestIssue: "v1/fuel/fill/request/issue",
    DirectIssueRequest: "v1/fuel/fill/direct/issue/request/create",
    DieselIssuedSync: "v1/fuel/fill/request/manual/sync",
    // DiselStatausList:"api/get/fuelFillRequest?pageSize=1&pageNo=1"
    // DiselStatausList:"api/get/fuelFillRequest?pageSize=1&pageNo=1",
    MenuList: "api/v1/menu/master/getAll",
    SubmenuList: "api/v1/get/all/submenu/master",
    Rolelist: "api/v1/get/allRole",
    savemenusubmenus: "api/v1/save/user/menu/submenu/map/data",
    // subusers endpoints
    SubUsersList: "api/v2/Subuser/all",
    AddSubUser: "api/v2/Subusers/add",
    SubUserById: "api/v2/subUser/byId",
    UpdateSubUser: "api/v2/subUser/update",
    // user vehicle mapping
    vehicleAddForAccess: "api/user/vehicles/details/add",
    existingVehicleAccess: "api/v2/get/user/vehicles/details",
    deleteVehicles: "api/user/vehicles/details/update",
    //vehicle Add
    addVehiclessave: "api/v2/vehicle/add",
    UpdateVehicles: "api/v2/vehicle/update",
    // certificatedata: "api/v1/getVehicleBy/certificateNo",
    certificatedata: "api/v2/getVehicleBy/certificateNo",

    vtsModelList: "api/v1/getBy/companyId",
    // vtsModelList: "api/v2/getBy/companyId",

    // Logo Add
    LogoUrl: "api/v1/update/delerLogo",
    cangepassword: "v2/change/password",
    vehiclesAllActivationList: "get/all/activation/request",

    //getAllDealerBalanceSheet: "api/v1/get/all/dealer/balance/sheet",

    getDealerLedgerById: "api/get/trans/dealer",
    getAllActivationRenewalRequests: "api/activation-renewal-requests/getAll",
    bulkUpdateActivationRenewal:
      "api/activation-renewal-requests/import/support/device/request",
    getAllActivationRenewalListToUpdate:
      "api/activation-renewal-requests/support/device/request",
    updateSingleVehicleDate:
      "api/activation-renewal-requests/support/device/request/update",
    subcruptionList: "api/dealer-subscriptions/getAll",
    viewsubcruption: "api/subscription-master/getAll",
    createsubscriptions: "api/dealer-subscriptions/create",
    updatesubscriptions: "api/dealer-subscriptions/update",
    getDealerSubscriptionbyID: "api/dealer-subscriptions/getById",
    getAllDealerBalanceSheet: "api/v1/get/all/dealer/balance/sheet",
    // getDealerLedgerById: "api/get/trans/dealer",
    // getAllActivationRenewalRequests:"api/activation-renewal-requests/getAll",
    approver: "",
    getByIdActivation: "api/activation-renewal-requests/getById",
    createaCtivationRenewal: "api/activation-renewal-requests/create",
    paymentMethode: "api/dealer/payment",
    dealearByVewPayment: "api/get/dealer/current-balance",
    AprrovedActivation: "api/activation-renewal-requests/apporve",
    currentBalance: "api/get/dealer/current-balance",
    addVehicleWithExcelOrMultiSelect: "api/import/user/vehicle",
    resetPassword: "v1/reset/password",
    forgotPassword: "v1/reset/password/link",
    newDashboardData: "api/v1/get/newDashboardData",
    commandsList: "api/v1/commands",
    commandShoot: "api/v1/command/shoot",
  },
};
